"use client";

import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import Image from "next/image";
import {
    CloseIcon,
    NewMenuIcon,
    WTLogoEnglish,
    BlackSimpleArrow,
} from "../../../public/Theme";
import CurrencySelectorDropdown from "../CurrencySelectorDropdown";
import {
    DROPDOWN_LINK,
    CLOSE_ICON_ALT,
    DRAWER_NAVIGATION,
    HEADER_BUTTON_ID,
    HEADER_LINK,
    HEADER_LOGIN_BUTTON_ID,
    HEADER_LOGO_IMAGE_ID,
    LAZY,
    LOGIN_ENDPOINT,
    LOGO_ALT_TEXT,
    MENU_ICON_ALT,
    slugify,
    COUNTRY_ICON_ALT,
    BACK_TEXT,
} from "./constants";
import {
    DASHBOARD_DRAWER_CLOSE_TRANSITION,
    DASHBOARD_DRAWER_CONTAINER,
    DRAWER_CLOSE_TRANSITION,
    DRAWER_INNER_CONTAINER,
    DRAWER_OPEN_TRANSITION,
    DRAWER_PARENT_CONTAINER,
    DROPDOWN_CLASS,
    HEADER_LINK_CLASS,
    LINKS_AND_BUTTONS_CONTAINER,
    LINKS_CONTAINER,
    LOGO_CLASS,
    LOGO_IMAGE_CLASS,
    MARGING_3,
    MENU_ICON_CLASS,
    MENU_IMAGE_CLASS,
    NAVBAR_CLASS,
    MX_AUTO,
    HEADER_CLASS,
} from "./styles";
import {
    BUTTON,
    LOGIN_TEXT,
    MINUS_ONE,
    MOBILE_SCREEN_BREAKPOINT,
    PADDING_LEFT_ZERO,
    WIDTH_113_PX,
    USER_COUNTRY,
    SAUDI_ISO,
} from "../../../public/Constants/EnumConstants";
import UserInitialsAvatar from "../UserInitialsAvatar";
import { useMediaQuery } from "../../CustomHooks/UseMediaQuery";
import { usePathname } from "next/navigation";
import GTMLink from "../../Atoms/GTMLink";
import { GoogleTagManagerEvents } from "../../../common";
import NewPrimaryButton from "../../Atoms/Buttons/NewPrimaryButton";
import HeaderLinkWithIcon from "../../Atoms/Typography/HeaderLinkWithIcon";
import NewHeaderLoginButton from "../../Atoms/Buttons/NewHeaderLoginButton";
import FlyoutLink from "../../Atoms/FlyoutLink";
import SideNavbarSections from "../../Molecules/SideNavbarSections";
import useUserStore from "../../../lib/Store/useUserStore";
const DashboardSidebar = dynamic(
    () => import("../DashboardSidebar/DashboardSidebar"),
    { ssr: false }
);

const NewHeaderSection = ({ homeUrl, userCountry }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [userInitials, setUserInitials] = useState(null);
    const [dashboardDrawerOpen, setDashboardDrawerOpen] = useState(false);
    const [sectionLinks, setSectionLinks] = useState(null);
    const { userData } = useUserStore();

    const breakPoint = useMediaQuery(MOBILE_SCREEN_BREAKPOINT);
    const { pathname } = usePathname();
    useEffect(() => {
        if (userData && Object.keys(userData).length !== 0) {
            setUserInitials(
                `${userData?.user?.first_name[0]?.toUpperCase()}${userData?.user?.last_name[0]?.toUpperCase()}`
            );
        }
    }, [userData]);

    return (
        <header className={HEADER_CLASS}>
            <nav
                className={
                    drawerOpen ? PADDING_LEFT_ZERO + NAVBAR_CLASS : NAVBAR_CLASS
                }
            >
                <div className={LINKS_AND_BUTTONS_CONTAINER}>
                    <button
                        type={BUTTON}
                        onClick={() => {
                            setDrawerOpen(!drawerOpen);
                            setDashboardDrawerOpen(false);
                        }}
                        data-drawer-target={DRAWER_NAVIGATION}
                        data-drawer-show={DRAWER_NAVIGATION}
                        // aria-controls={DRAWER_NAVIGATION}
                        className={MENU_ICON_CLASS}
                    >
                        <Image
                            src={NewMenuIcon}
                            alt={MENU_ICON_ALT}
                            className={MENU_IMAGE_CLASS}
                            width={50}
                            height={50}
                        />
                    </button>
                    <GTMLink
                        text={"Home"}
                        href={homeUrl}
                        passHref
                        prefetch
                        replace={true}
                        className={LOGO_CLASS}
                        event={GoogleTagManagerEvents.navigationInteractions}
                        place="header"
                        menuName={"header navigation menu"}
                    >
                        <Image
                            width={100}
                            height={100}
                            src={WTLogoEnglish}
                            className={LOGO_IMAGE_CLASS}
                            alt={LOGO_ALT_TEXT}
                            id={HEADER_LOGO_IMAGE_ID}
                            data-cy={HEADER_LOGO_IMAGE_ID}
                        />
                    </GTMLink>
                    <div className={LINKS_CONTAINER}>
                        <ul className="flex flex-col mt-4 font-medium lg:flex-row  lg:mt-0 px-14 ">
                            {HEADER_LINK?.map((item, index) => (
                                <FlyoutLink
                                    key={index}
                                    flyoutLinks={item?.flyout_links}
                                    link={item?.link}
                                    headerId={slugify(
                                        HEADER_BUTTON_ID + `_${item?.text}`
                                    )}
                                >
                                    {item?.text}
                                </FlyoutLink>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className={LINKS_AND_BUTTONS_CONTAINER}>
                    {!userData ? (
                        <NewHeaderLoginButton
                            text={LOGIN_TEXT}
                            href={LOGIN_ENDPOINT}
                            width={WIDTH_113_PX}
                            headerId={HEADER_LOGIN_BUTTON_ID}
                        ></NewHeaderLoginButton>
                    ) : (
                        <div
                            onClick={() => {
                                if (breakPoint) {
                                    setDashboardDrawerOpen(
                                        !dashboardDrawerOpen
                                    );
                                    setDrawerOpen(false);
                                }
                            }}
                            className={DROPDOWN_CLASS}
                        >
                            <UserInitialsAvatar
                                text={userInitials}
                                topBar
                                breakPoint={breakPoint}
                                userData={userData}
                            />
                        </div>
                    )}
                    <div className="ml-4">
                        <CurrencySelectorDropdown
                            userCountry={userCountry}
                            userData={userData}
                        />
                    </div>

                    {/* <div
            className={
              lang === ARABIC
                ? SWITCHER_LINKS_CONTAINER_ARABIC
                : SWITCHER_LINKS_CONTAINER
            }
          >
            <NewNotificationBellIcon count={2} />
          </div> */}
                </div>
            </nav>

            <div
                onClick={() => setDashboardDrawerOpen(!dashboardDrawerOpen)}
                className={
                    DRAWER_PARENT_CONTAINER +
                    (dashboardDrawerOpen && breakPoint
                        ? DRAWER_OPEN_TRANSITION
                        : DASHBOARD_DRAWER_CLOSE_TRANSITION)
                }
                tabIndex={MINUS_ONE}
                dir="ltr"
            >
                <div className={DASHBOARD_DRAWER_CONTAINER}>
                    <div
                        className={"-mb-11"}
                        onClick={() =>
                            setDashboardDrawerOpen(!dashboardDrawerOpen)
                        }
                    >
                        <Image
                            src={CloseIcon}
                            width={25}
                            height={25}
                            alt="close-icon"
                        />
                    </div>
                    <DashboardSidebar
                        userData={userData}
                        setDashboardDrawerOpen={setDashboardDrawerOpen}
                    />
                </div>
            </div>

            <div
                className={
                    DRAWER_PARENT_CONTAINER +
                    (drawerOpen
                        ? DRAWER_OPEN_TRANSITION
                        : DRAWER_CLOSE_TRANSITION)
                }
            >
                <div
                    id={DRAWER_NAVIGATION}
                    className="block xl:hidden fixed z-40 h-screen top-0 p-4 overflow-y-auto bg-white w-max "
                    tabIndex={MINUS_ONE}
                >
                    <div className="flex flex-row justify-between items-center">
                        <div>
                            <button
                                className={`${!sectionLinks ? "hidden" : "block"} flex justify-center items-center font-Montserrat font-bold text-sm`}
                                onClick={() => {
                                    setSectionLinks(null);
                                }}
                            >
                                <Image
                                    src={BlackSimpleArrow}
                                    width={14}
                                    height={14}
                                    className="rotate-180 mr-2"
                                    alt={"Back button"}
                                />
                                {BACK_TEXT}
                            </button>
                        </div>
                        <div
                            className={`${sectionLinks ? "hidden" : "block"} `}
                        >
                            <GTMLink
                                event={
                                    GoogleTagManagerEvents.navigationInteractions
                                }
                                menuName={"header navigation menu"}
                                place={"header"}
                                href={homeUrl}
                                prefetch
                            >
                                <Image
                                    width={100}
                                    height={100}
                                    src={WTLogoEnglish}
                                    className={LOGO_IMAGE_CLASS + MX_AUTO}
                                    alt={LOGO_ALT_TEXT}
                                    loading={LAZY}
                                />
                            </GTMLink>
                        </div>
                        <button
                            type={BUTTON}
                            data-drawer-dismiss={DRAWER_NAVIGATION}
                            aria-controls={DRAWER_NAVIGATION}
                            onClick={() => {
                                setSectionLinks(null);
                                setDrawerOpen(!drawerOpen);
                            }}
                            className="bg-transparent rounded-lg "
                        >
                            <Image
                                width={25}
                                height={25}
                                src={CloseIcon}
                                alt={CLOSE_ICON_ALT}
                                loading={LAZY}
                            />
                        </button>
                    </div>
                    {!sectionLinks ? (
                        <>
                            <div className="py-8 overflow-y-none">
                                <ul className="">
                                    {HEADER_LINK?.map((item, index) => (
                                        <li key={index}>
                                            <HeaderLinkWithIcon
                                                text={item?.text}
                                                flyoutLinks={item?.flyout_links}
                                                link={item?.link}
                                                setSectionLinks={
                                                    setSectionLinks
                                                }
                                                onClick={() =>
                                                    setDrawerOpen(!drawerOpen)
                                                }
                                            />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            {!userInitials && (
                                <div className="w-full flex justify-center">
                                    <NewPrimaryButton
                                        event={
                                            GoogleTagManagerEvents.navigationInteractions
                                        }
                                        place="header"
                                        menuName={"header navigation menu"}
                                        width=" !w-36 justify-center "
                                        text={LOGIN_TEXT}
                                        href={`${LOGIN_ENDPOINT}`}
                                        onClick={() =>
                                            setDrawerOpen(!drawerOpen)
                                        }
                                    />
                                </div>
                            )}
                        </>
                    ) : (
                        <SideNavbarSections
                            links={sectionLinks}
                            onClick={() => {
                                setSectionLinks(null);
                                setDrawerOpen(!drawerOpen);
                            }}
                        />
                    )}
                </div>
                <div
                    className="flex-1"
                    onClick={() => {
                        setSectionLinks(null);
                        setDrawerOpen(!drawerOpen);
                    }}
                />
            </div>
        </header>
    );
};

export default NewHeaderSection;
